import { Toaster } from "@npco/zeller-design-system";
import { useMemo, type ReactNode } from "react";

import { RouteContext } from "./shared/route-context";

export namespace RouteProvider {
	export type Props = {
		children?: ReactNode;
	} & RouteContext;
}

export function RouteProvider({
	children,
	apiClient,
	wsClient,
	getNowDate,
	healthcheck,
}: RouteProvider.Props) {
	const value = useMemo(
		() => ({ apiClient, wsClient, getNowDate, healthcheck }),
		[apiClient, wsClient, getNowDate, healthcheck],
	);
	return (
		<RouteContext.Provider value={value}>
			<Toaster.Provider>{children}</Toaster.Provider>
		</RouteContext.Provider>
	);
}
